module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "blog",
    attrs: {
      "id": "blog"
    }
  }, [_c('h5', {
    staticClass: "center"
  }, [_vm._v("Blog (Portuguese BR only)")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "post"
    }
  }, _vm._l((_vm.posts), function(post, key, index) {
    return _c('div', {
      key: post,
      staticClass: "row row-post"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('i', {
      staticClass: "fa fa-calendar-o"
    }), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm.formataData(post.date)))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('a', {
      staticClass: "scrollSoft left",
      attrs: {
        "href": post.link
      }
    }, [_c('h4', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(post.title) + " ")])])])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25190c24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jm-c-blog.vue
// module id = 416
// module chunks = 1